import AnkleCuffs from './AnkleCuffs';
import Ballgag from './Ballgag';
import ButtPlug from './ButtPlug';
import ButtPlugIcon from './ButtPlugIcon';
import Collar from './Collar';
import Dildo from './Dildo';
import DildoIcon from './DildoIcon';
import EyeMask from './EyeMask';
import GlassDildo from './GlassDildo';
import GlassDildoIcon from './GlassDildoIcon';
import Handcuffs from './Handcuffs';
import HeartCollar from './HeartCollar';
import Karada from './Karada';
import LatexMask from './LatexMask';
import MiniPeen from './MiniPeen';
import MiniPeenIcon from './MiniPeenIcon';
import PeenPaddle from './PeenPaddle';
import PeenPaddleIcon from './PeenPaddleIcon';
import RopeCuffs from './RopeCuffs';
import SlutPaddle from './SlutPaddle';
import SlutPaddleIcon from './SlutPaddleIcon';
import Wand from './Wand';
import WandIcon from './WandIcon';

export {
  AnkleCuffs,
  Ballgag,
  ButtPlug,
  ButtPlugIcon,
  Collar,
  Dildo,
  DildoIcon,
  EyeMask,
  GlassDildo,
  GlassDildoIcon,
  Handcuffs,
  HeartCollar,
  Karada,
  LatexMask,
  MiniPeen,
  MiniPeenIcon,
  PeenPaddle,
  PeenPaddleIcon,
  RopeCuffs,
  SlutPaddle,
  SlutPaddleIcon,
  Wand,
  WandIcon
}


// WEBPACK FOOTER //
// ./src/game/components/toys/index.js